// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"player-audio_Wrapper__t_Q_9","Player":"player-audio_Player__yDMDm","Timer":"player-audio_Timer__np7zg"};